import React from 'react'
import NextLink, { LinkProps } from 'next/link'

type Props = React.PropsWithChildren<
  Omit<LinkProps, 'href' | 'style'> & {
    href?: string
    title?: string
    forceExternal?: boolean
    forceShow?: boolean
    style?: any
  }
>

const NextALink: React.FC<Props> = ({
  href = '',
  title,
  forceExternal = false,
  forceShow = false,
  children,
  onClick,
  style,
  ...linkProps
}) => {
  if (!forceShow && (!href?.length || href === '#')) {
    if (!onClick) {
      return null
    }

    return (
      <a title={title} onClick={onClick} style={style}>
        {children}
      </a>
    )
  }

  let targetProps = {}
  if (forceExternal || href?.startsWith('http')) {
    targetProps = { target: '_blank', rel: 'noopener noreferrer' }

    return (
      <a href={href} onClick={onClick} title={title} style={style} {...targetProps} {...linkProps}>
        {children}
      </a>
    )
  }

  return (
    <NextLink href={href} passHref {...linkProps} legacyBehavior>
      <a title={title} onClick={onClick} style={style}>
        {children}
      </a>
    </NextLink>
  )
}

export default NextALink
